module.exports = __webpack_public_path__ + "media/assets/good_at/pve-dd6b7902eb7979b4a87fa2486b5b3527.png";